import * as React from "react"

import { ICategoryOrProduct } from "shared/hubrise/models"

import Delete from "./Delete"
import Preview from "./Preview"

const Commands = ({ categoryOrProduct }: { categoryOrProduct: ICategoryOrProduct }): JSX.Element => (
  <>
    <Preview categoryOrProduct={categoryOrProduct} />
    <Delete categoryOrProduct={categoryOrProduct} />
  </>
)

export default Commands
